<template>
  <div class="search-filter">
    <div class="search-filter-inner">
      <div class="filter-container">
        <div class="search-box">
          <form @submit.prevent="onSubmitSearch">
            <input
              type="text"
              class="search-box-input"
              placeholder="Search"
              v-model="filter.search"
            >
          </form>
          <div class="icon" :style="{ backgroundImage: `url(${imgs.magnifier})` }"></div>
        </div>
        <div class="filter-toggle" :class="{ 'active': openFilterPanel }" @click="toggleFilter">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21.874"
            height="17.923"
            viewBox="0 0 21.874 17.923"
            class="toggle-icon"
          >
            <g id="Group_337" data-name="Group 337" transform="translate(-1006.224 -127.958)">
              <path
                id="Path_5162"
                data-name="Path 5162"
                d="M1027.36,129.763h-9.815a2.58,2.58,0,0,0-4.922,0h-5.662a.738.738,0,0,0-.738.738v.072a.738.738,0,0,0,.738.738h5.662a2.58,2.58,0,0,0,4.922,0h9.815a.738.738,0,0,0,.738-.738V130.5A.738.738,0,0,0,1027.36,129.763Z"
                fill="#2c2c2c"
              ></path>
              <path
                id="Path_5163"
                data-name="Path 5163"
                d="M1027.36,251.313h-1.414a2.579,2.579,0,0,0-4.807,0h-14.177a.738.738,0,0,0-.738.738v.072a.738.738,0,0,0,.738.738h14.075a2.579,2.579,0,0,0,5.011,0h1.312a.738.738,0,0,0,.738-.738v-.072A.738.738,0,0,0,1027.36,251.313Z"
                transform="translate(0 -115.167)"
                fill="#2c2c2c"
              ></path>
              <path
                id="Path_5164"
                data-name="Path 5164"
                d="M1027.36,367.177h-14.284a2.58,2.58,0,0,0-4.922,0h-1.192a.738.738,0,0,0-.738.738v.072a.738.738,0,0,0,.738.738h1.192a2.58,2.58,0,0,0,4.922,0h14.284a.738.738,0,0,0,.738-.738v-.072A.738.738,0,0,0,1027.36,367.177Z"
                transform="translate(0 -224.649)"
                fill="#2c2c2c"
              ></path>
            </g>
          </svg>
          <span>Filter</span>
        </div>
      </div>
      <div class="submenu" :class="{ 'show': openFilterPanel }">
        <div class="selectable-filter-items">
          <template v-if="filterMode === 'travelerTypes'">
            <div
              v-for="t in $store.state.ref.travelerTypes"
              :key="t.id"
              class="filter-item"
              :class="{ 'selected': filter.travelerTypes.indexOf(t.id) > -1,  'small-text': t.title.length > 20 }"
              @click="onClickTravelerType(t.id)"
              :style="{backgroundColor: t.color}"
            >
              <span>{{t.title}}</span>
            </div>
          </template>
          <template v-else>
            <div
              v-for="c in $store.state.ref.categories"
              :key="c.id"
              class="filter-item"
              :class="{ 'selected': filter.categories.indexOf(c.id) > -1,  'small-text': c.title.length > 20 }"
              @click="onClickCategory(c.id)"
              :style="{backgroundColor: c.color}"
            >
              <span>{{c.title}}</span>
            </div>
          </template>
        </div>
        <div class="selectable-filter-tools">
          <div
            class="selectable-filter-modes"
            @click="toggleFilterMode"
          >Search by {{filterMode === 'travelerTypes' ? 'categories' : 'traveler themes'}}</div>
          <div class="selectable-filter-buttons">
            <button class="btn btn-danger" @click="selectAllFilters()">Select All</button>
            <button class="btn btn-danger" @click="resetFilters()">Reset</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import magnifier from "@/assets/img/magnifier.svg";
export default {
  name: "SearchFilter",
  data() {
    return {
      openFilterPanel: false,
      filterMode: "travelerTypes",
      imgs: {
        magnifier
      },
      filter: {
        search: "",
        travelerTypes: [],
        categories: []
      }
    };
  },
  methods: {
    toggleFilterMode() {
      this.filterMode =
        this.filterMode === "travelerTypes" ? "categories" : "travelerTypes";
      this.resetFilters();
    },
    selectAllFilters() {
      if (this.filterMode === "travelerTypes") {
        this.filter.travelerTypes = this.$store.state.ref.travelerTypes.map(
          it => it.id
        );
      } else {
        this.filter.categories = this.$store.state.ref.categories.map(it => it.id);
      }
      this.emitSearch();
    },
    resetFilters() {
      this.filter.travelerTypes = [];
      this.filter.categories = [];
      this.emitSearch();
    },
    onSubmitSearch() {
      this.emitSearch();
    },
    onClickTravelerType(value) {
      const index = this.filter.travelerTypes.indexOf(value);
      if (index > -1) {
        this.filter.travelerTypes.splice(index, 1);
      } else {
        this.filter.travelerTypes.push(value);
        this.filter.travelerTypes.sort();
      }
      this.emitSearch();
    },
    onClickCategory(value) {
      const index = this.filter.categories.indexOf(value);
      if (index > -1) {
        this.filter.categories.splice(index, 1);
      } else {
        this.filter.categories.push(value);
        this.filter.categories.sort();
      }
      this.emitSearch();
    },
    emitSearch() {
      this.$emit("update", Object.create(this.filter));
    },
    toggleFilter() {
      this.openFilterPanel = !this.openFilterPanel;
      this.emitFilter();
    },
    emitFilter() {
      this.$emit("openFilter", this.openFilterPanel);
    }
  }
};
</script>

<style lang="scss" scoped>
.search-filter {
  position: fixed;
  top: 52px;
  left: 0;
  z-index: 1002;
  width: 100%;

  .search-filter-inner {
    position: relative;
    width: 100%;
  }

  .filter-container {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    width: 100%;
    display: flex;
    background-color: #fff;
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.1);
  }
  .search-box {
    flex: 1;
    position: relative;
    input {
      width: 100%;
      height: 44px;
      font-size: 15px;
      border: none;
      border-right: 1px solid rgba(44, 44, 44, 0.35);
      padding: 10px 41px 10px 20px;
      outline: none;
      &:focus {
        outline: none;
      }
    }
    .icon {
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      position: absolute;
      top: 50%;
      right: 15px;
      transform: translateY(-50%);
      width: 21px;
      height: 21px;
      z-index: 2;
      pointer-events: none;
    }
  }
  .filter-toggle {
    flex: 0 0 auto;
    width: 124px;
    user-select: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 15px;

    .toggle-icon {
      display: inline-block;
      margin-right: 10px;
    }

    &.active {
      color: #e13036;

      svg path {
        fill: #e13036;
      }
    }
  }
  .submenu {
    background-color: #fff;
    width: 100%;
    top: -190px;
    transition: 0.3s ease all;
    position: absolute;
    left: 0;
    z-index: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    &.show {
      top: calc(100% + 44px);
      opacity: 1;
    }

    .selectable-filter-items {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-auto-rows: 40px;

      .filter-item {
        font-size: 15px;
        line-height: 40px;
        text-align: center;
        background-color: #e13036;

        span {
          background-color: white;
          color: #2c2c2c;
          width: 100%;
          height: 100%;
          display: block;
          transition: 0.3s ease all;
          border-bottom: 1px solid #d6d6d6;
        }

        &:nth-child(2n - 1) span {
          border-right: 1px solid #d6d6d6;
        }

        &.small-text {
          font-size: 12px;
        }

        &.selected {
          span {
            background-color: transparent;
            color: #fff;
          }
        }
      }
    }

    .selectable-filter-tools {
      display: flex;

      .selectable-filter-modes,
      .selectable-filter-buttons {
        flex: 0 0 auto;
        width: 50%;
      }

      .selectable-filter-buttons {
        display: flex;

        button {
          width: 50%;
          padding: 6px 0;
          border-radius: 0;
          font-size: 12px;
          outline: none;

          &:focus {
            outline: none;
            box-shadow: none;
          }

          & + button {
            margin-left: 2px;
          }
        }
      }

      .selectable-filter-modes {
        color: #e13036;
        font-size: 11px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>
